import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';

@Component({
  selector: 'app-view-invoices',
  templateUrl: './view-invoices.component.html',
  styleUrls: ['./view-invoices.component.css']
})
export class ViewInvoicesComponent implements OnInit {
  invoice: any;
  constructor(private g: Globals, private route: ActivatedRoute, private api: ApiIntegration, public user: User) {
    this.g.page = "Invoice Details";
    this.api.getInvoicesById(this.route.snapshot.params['id']).subscribe((data: any) => { this.invoice = data; }, err => { console.log(err); });
  }

  ngOnInit() {
  }

}
